import { CommonModule } from "@angular/common";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NavController, NavParams, LoadingController, ModalController, IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgxMaskDirective, NgxMaskPipe } from "ngx-mask";
import { Observable } from "rxjs";
import { EnderecoProvider } from "src/app/services/endereco/endereco";
import { GrupoProvider } from "src/app/services/grupo/grupo";
import { MapaProvider } from "src/app/services/mapa/mapa";
import { UserProvider } from "src/app/services/user/user";
declare var google: any;
const idBrasil = 27;
const idDubai = 2;

@Component({
  selector: "app-grupo-adm-endereco",
  templateUrl: "./grupo-adm-endereco.page.html",
  styleUrls: ["./grupo-adm-endereco.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule,
    NgxMaskPipe,
    NgxMaskDirective,
  ],
})
export class GrupoAdmEnderecoPage implements OnInit {
  @ViewChild("searchbar", { read: ElementRef })
  searchbar!: ElementRef;
  addressElement: HTMLInputElement | null = null;
  address = "";
  pais;
  componentEndereco: any = {};
  selecionado: boolean = false;
  endereco: any = {};
  validations_form: FormGroup;
  validations_form_internacional: FormGroup;

  idInstituicao: any;
  regiao: any = [];
  paises: any = [];
  estados: any = [];
  cidades: any = [];
  semEstado: boolean = false;
  paisList: any = [];
  dubai = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    public translate: TranslateService,
    public userProvider: UserProvider,
    public grupoProvider: GrupoProvider,
    public loadingController: LoadingController,
    public enderecoProvider: EnderecoProvider,
    public mapaService: MapaProvider
  ) {
    this.endereco = this.navParams.get("endereco");

    this.enderecoProvider.getPaises().subscribe((data) => {
      this.paises = data;
      setTimeout(() => {
        this.userProvider.getDadosInstituicao().then((data) => {
          this.idInstituicao = data.id;
          this.enderecoProvider.getAreaRegiao(this.idInstituicao).subscribe((data) => {
            this.regiao = data;
          });
        });
      }, 1000);
    });

    if (this.endereco.idPais) {
      this.dubai = Number(this.endereco.idPais) === idDubai ? true : false;

      if (this.endereco.idPais == 27) {
        this.semEstado = false;
      } else {
        this.semEstado = true;
      }

      this.enderecoProvider.getEstados(this.endereco.idPais).subscribe((data) => {
        if (data.showEstados) {
          this.estados = data.estadoList;

          if (this.endereco.idEstado) {
            this.enderecoProvider.getCidades(this.endereco.idEstado).subscribe((data) => {
              this.cidades = data;
            });
          }
        }
      });
    }

    this.validations_form_internacional = this.formBuilder.group({
      idPais: new FormControl(String(this.endereco.idPais), Validators.compose([Validators.required])),
      enderecoGoogle: new FormControl(this.endereco.formatado, Validators.compose([Validators.required])),
      numero: new FormControl(this.endereco.numero),
      complemento: new FormControl(this.endereco.complemento),
      estadoNome: new FormControl(this.endereco.estadoNome),
      cep: new FormControl(this.endereco.cep),
      logradouro: new FormControl(this.endereco.logradouro),
      bairro: new FormControl(this.endereco.bairro),
      cidadeNome: new FormControl(this.endereco.cidadeNome),
      paisNome: new FormControl(this.endereco.paisNome),
    });

    this.validations_form = this.formBuilder.group({
      idPais: new FormControl(this.endereco.idPais),
      cep: new FormControl(this.endereco.cep),
      logradouro: new FormControl(this.endereco.logradouro),
      numero: new FormControl(this.endereco.numero),
      complemento: new FormControl(this.endereco.complemento),
      bairro: new FormControl(this.endereco.bairro),
      idEstado: new FormControl(this.endereco.idEstado),
      idCidade: new FormControl(this.endereco.idCidade),
      cidadeNome: new FormControl(this.endereco.cidadeNome),
      caixaPostal: new FormControl(this.endereco.cep),
      idRegiao: new FormControl(this.endereco.idRegiao),
    });

    this.pais = this.endereco.idPais;
  }

  ngOnInit() {}

  ionViewDidLoad() {
    this.enderecoProvider.getPaises().subscribe((data) => {
      this.paisList = data;
      this.initAutocomplete();
    });
  }

  initAutocomplete(): void {
    this.addressElement = this.searchbar.nativeElement.querySelector(".text-input");

    if (this.addressElement) {
      this.createAutocomplete(this.addressElement).subscribe((location) => {
        let latLngObj = { lat: location.lat(), long: location.lng() };
        this.getAddress(latLngObj);
      });
    }
  }

  createAutocomplete(addressEl: HTMLInputElement): Observable<any> {
    const autocomplete = new google.maps.places.Autocomplete(addressEl);
    return new Observable((sub: any) => {
      google.maps.event.addListener(autocomplete, "place_changed", () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          sub.error({
            message: "Autocomplete returned place with no geometry",
          });
        } else {
          let latLngObj = {
            lat: place.geometry.location.lat(),
            long: place.geometry.location.lng(),
          };
          this.getAddress(latLngObj);
          sub.next(place.geometry.location);
        }
      });
    });
  }

  getAddress(latLngObj: any) {
    this.mapaService.getStreetAddress(latLngObj).subscribe(
      (s_address) => {
        if (s_address.status == "ZERO_RESULTS") {
          this.mapaService.getAddress(latLngObj).subscribe(
            (address) => {
              this.address = address.results[0].formatted_address;
              this.getAddressComponentByPlace(address.results[0], latLngObj);
            },
            (err) => console.log("Error in getting the street address " + err)
          );
        } else {
          this.address = s_address.results[0].formatted_address;
          this.getAddressComponentByPlace(s_address.results[0], latLngObj);
        }
      },
      (err) => {
        console.log("No Address found " + err);
      }
    );
  }

  getAddressComponentByPlace(place: any, latLngObj: any) {
    let components: any;
    components = {};

    for (var i = 0; i < place.address_components.length; i++) {
      let ac = place.address_components[i];
      components[ac.types[0]] = ac.long_name;
    }

    this.selecionado = true;

    this.componentEndereco = components;
    this.componentEndereco.longitude = latLngObj.long;
    this.componentEndereco.latitude = latLngObj.lat;

    return components;
  }

  mudarPais(event: CustomEvent) {
    this.dubai = Number(event.detail.value) === idDubai ? true : false;
    this.semEstado = Number(event.detail.value) === idBrasil ? false : true;

    if (this.semEstado) {
      const control = this.validations_form_internacional.get("idPais");
      control?.reset();
      control?.setValue(event.detail.value);
      this.pais = event.detail.value;
      this.initAutocomplete();
    } else {
      const idPais = this.validations_form.get("idPais");
      idPais?.reset();
      idPais?.setValue(event.detail.value);
    }

    this.enderecoProvider.getEstados(event.detail.value).subscribe((data) => {
      if (data.showEstados) {
        this.estados = data.estadoList;
        if (this.endereco.idEstado) {
          this.enderecoProvider.getCidades(this.endereco.idEstado).subscribe((data) => {
            this.cidades = data;
          });
        }
      }
    });
  }

  buscar() {
    this.enderecoProvider.getAreaRegiao(this.idInstituicao.id).subscribe((data) => {
      this.regiao = data;
    });
  }

  mudarEstado(idEstado: any) {
    this.enderecoProvider.getCidades(idEstado).subscribe((data) => {
      this.cidades = data;
    });
  }

  buscarCep() {
    let cep = this.validations_form.get("cep")?.value.replace(/\D+/g, "");
    if (cep.length == 8) {
      this.enderecoProvider.getCEP(cep).subscribe((data) => {
        if (data.logradouro) {
          this.validations_form.patchValue({
            logradouro: data.tp_logradouro + " " + data.logradouro,
            bairro: data.bairro,
            idPais: parseInt(data.idPais),
            idEstado: parseInt(data.estado_id),
            idCidade: parseInt(data.cidade_id),
          });

          this.enderecoProvider.getEstados(data.idPais).subscribe((estado) => {
            this.estados = estado.estadoList;
          });

          this.enderecoProvider.getCidades(data.estado_id).subscribe((cidades) => {
            this.cidades = cidades;
          });
        }
      });
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  onSubmitInternacional(endereco: any) {
    this.dubai ? this.onSubmitDubai(endereco) : this.salvarEnderecoGoogle(endereco);
  }

  salvarEnderecoGoogle(endereco: any) {
    this.grupoProvider
      .salvarEnderecoGoogle(this.endereco.id, this.address, endereco.idPais, this.componentEndereco)
      .subscribe((data) => {
        this.modalCtrl.dismiss(data);
      });
  }

  onSubmit(e: {
    idPais: any;
    caixaPostal: any;
    logradouro: any;
    complemento: any;
    cidadeNome: any;
    cep: string;
    numero: any;
    bairro: any;
    idEstado: any;
    idCidade: any;
    idEndereco: any;
  }) {
    if (this.semEstado) {
      this.endereco.idPais = e.idPais;
      this.endereco.cep = e.caixaPostal;
      this.endereco.logradouro = e.logradouro;
      this.endereco.complemento = e.complemento;
      this.endereco.cidadeNome = e.cidadeNome;
    } else {
      this.endereco.idPais = e.idPais;
      if (e.cep) {
        this.endereco.cep = e.cep.replace(/\D+/g, "");
      }
      this.endereco.logradouro = e.logradouro;
      this.endereco.numero = e.numero;
      this.endereco.complemento = e.complemento;
      this.endereco.bairro = e.bairro;
      this.endereco.idEstado = e.idEstado;
      this.endereco.idCidade = e.idCidade;
    }

    e.idEndereco = this.endereco.id;

    this.grupoProvider.salvarEndereco(e).subscribe((data) => {
      this.modalCtrl.dismiss(data);
    });
  }

  onSubmitDubai(endereco: any) {
    const paisNome = this.paises.find((pais: any) => pais.id == endereco.idPais).nome;

    this.endereco = {
      complemento: endereco.complemento,
      logradouro: endereco.logradouro,
      cidadeNome: endereco.cidadeNome,
      estadoNome: endereco.estadoNome,
      idEndereco: this.endereco.id,
      idPais: endereco.idPais,
      bairro: endereco.bairro,
      numero: endereco.numero,
      cep: endereco.cep,
      paisNome: paisNome,
      estadoSigla: null,
      formatado: null,
      idEstado: null,
      idCidade: null,
    };

    this.endereco = this.formatarEnderecoDubai(this.endereco);
    this.salvarEndereco(this.endereco);
  }

  private salvarEndereco(endereco: any) {
    this.grupoProvider.salvarEndereco(endereco).subscribe(
      (data) => this.modalCtrl.dismiss(data),
      (error) => console.error("Erro ao salvar o endereço:", error)
    );
  }

  formatarEnderecoDubai(endereco: any) {
    const { complemento, logradouro, numero, bairro, cidadeNome, cep, estadoNome, paisNome } = endereco;
    const camposEndereco = [complemento, logradouro, numero, bairro, cidadeNome];

    let enderecoFormatado = camposEndereco.filter(Boolean).join(", ");

    if (cep) {
      enderecoFormatado += `, ${cep}`;
    }

    if (estadoNome) {
      enderecoFormatado += ` - ${estadoNome}`;
    }

    enderecoFormatado += ` - ${paisNome}`;

    endereco.formatado = enderecoFormatado;

    return endereco;
  }
}
